import { Box, Collapse, IconButton, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function AlertErrors({
  openFailure,
  openSuccess,
  failureMessage,
  successMessage,
  setOpenFailure,
  setOpenSuccess,
  id,
  alertSx
}) {
  return (
    <Box id={id} sx={{ width: "100%" }}>
      <Collapse in={openFailure}>
        <Alert
          sx={alertSx ? { ...alertSx, border: '1px solid red' } : { m: 1, border: '1px solid red' }}
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpenFailure(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {failureMessage}
        </Alert>
      </Collapse>
      <Collapse in={openSuccess}>
        <Alert
          sx={alertSx ? { ...alertSx, border: '1px solid green' } : { m: 1, border: '1px solid green' }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpenSuccess(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {successMessage}
        </Alert>
      </Collapse>
    </Box>
  );
}
